export const routes = (parentName) => {
  return [
    {
      path: "teaching",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-Teaching`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        // {
        //   path: "new",
        //   name: `${parentName}-Job-Position-New`,
        //   component: () => import("./Upsert.vue"),
        // },
        // {
        //   path: ":id/edit",
        //   name: `${parentName}-Job-Position-Edit`,
        //   component: () => import("./Upsert.vue"),
        // },
        // {
        //   path: ":id",
        //   name: parentName + "-" + "Job-Position-View",
        //   component: () => import("./View.vue"),
        // },
      ],
    },
  ];
};
